import React, { useState, useEffect } from "react";
import { data } from "react-router-dom";

function StudentmyDetails() {
    const [formData, setFormData] = useState({
        fname: "",
        lname: "",
        email: "",
        phone: "",
        bio: "",
        image: null,
    });
    const [imagePreview, setImagePreview] = useState("assets/images/thumbs/setting-profile-img.jpg");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);

    // Fetch student details by ID
    useEffect(() => {
        const studentId =localStorage.getItem('stdid');
        if (studentId) {
            fetch(`https://api.itrain.io/student/getStudentById/${studentId}`)
                .then((response) => response.json())
                .then((data) => {
                    if (data.success && data.student) {
                        const student = data.student;
                        console.log(student)
                        setFormData({
                            fname: student.firstName || "",
                            lname: student.lastName || "",
                            email: student.email || "",
                            phone: student.mobile || "",
                            image: null, 
                        });
                        // Update image preview if there's a valid image (not present in your response)
                        setImagePreview("assets/images/thumbs/setting-profile-img.jpg");
                    }
                })
                .catch((error) => {
                    console.error("Error fetching student details:", error);
                });
        }
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
            setFormData((prevData) => ({ ...prevData, image: file }));
        }
    };

    const handleSave = (e) => {
        e.preventDefault();
    
        const studentId = localStorage.getItem('stdid');
        if (studentId) {
            // Fetch the student's current details
            fetch(`https://api.itrain.io/student/getStudentById/${studentId}`)
                .then((response) => response.json())
                .then((data) => {
                    if (data.success && data.student) {
                        const student = data.student;
                        console.log(student);
    
                        // Prepare updated form data
                        const updatedFormData = {
                            firstName: formData.fname || "",
                            lastName: formData.lname || "",
                            email: student.email || "",
                            mobile: formData.phone || "",
                            image: formData.image, // You can handle image updates separately if needed
                        };
    
                        // PUT request to update the student's details
                        fetch(`https://api.itrain.io/student/updateStudent/${studentId}`, {
                            method: "PUT",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(updatedFormData),
                        })
                            .then((updateResponse) => updateResponse.json())
                            .then((updateData) => {
                                if (updateData.success) {
                                    console.log("Student details updated successfully:", updateData);
                                } else {
                                    console.error("Failed to update student details:", updateData.message);
                                }
                            })
                            .catch((error) => {
                                console.error("Error updating student details:", error);
                            });
                    }
                })
                .catch((error) => {
                    console.error("Error fetching student details:", error);
                });
        } else {
            console.error("Student ID not found in localStorage.");
        }
    };
    
    

    const closeModal = () => {
        setIsModalOpen(false);
        setFormData({
            fname: "",
            lname: "",
            email: "",
            phone: "",
            image: null,
        });
        setImagePreview("assets/images/thumbs/setting-profile-img.jpg");
    };

    useEffect(() => {
        const { fname, lname, email, phone, image } = formData;
        const isValid = fname && lname && email && phone  && image;
        setIsFormValid(isValid);
    }, [formData]);

    return (
        <div className="tab-pane fade show active" id="pills-details" role="tabpanel">
            <div className="card mt-24">
                <div className="card-header border-bottom">
                    <h4 className="mb-4">My Details</h4>
                    <p className="text-gray-600 text-15">Please fill full details about yourself</p>
                </div>
                <div className="card-body">
                    <form onSubmit={handleSave}>
                        <div className="row gy-4">
                            <div className="col-sm-6 col-xs-6">
                                <label htmlFor="fname" className="form-label mb-8 h6">First Name</label>
                                <input
                                    type="text"
                                    className="form-control py-11"
                                    id="fname"
                                    name="fname"
                                    value={formData.fname}
                                    onChange={handleInputChange}
                                    placeholder="Enter First Name"
                                />
                            </div>
                            <div className="col-sm-6 col-xs-6">
                                <label htmlFor="lname" className="form-label mb-8 h6">Last Name</label>
                                <input
                                    type="text"
                                    className="form-control py-11"
                                    id="lname"
                                    name="lname"
                                    value={formData.lname}
                                    onChange={handleInputChange}
                                    placeholder="Enter Last Name"
                                />
                            </div>
                            <div className="col-sm-6 col-xs-6">
                                <label htmlFor="email" className="form-label mb-8 h6">Email</label>
                                <input
                                    type="email"
                                    className="form-control py-11"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    placeholder="Enter Email"
                                />
                            </div>
                            <div className="col-sm-6 col-xs-6">
                                <label htmlFor="phone" className="form-label mb-8 h6">Phone Number</label>
                                <input
                                    type="number"
                                    className="form-control py-11"
                                    id="phone"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                    placeholder="Enter Phone Number"
                                />
                            </div>
                            <div className="col-12">
                                <label htmlFor="imageUpload" className="form-label mb-8 h6">Your Photo</label>
                                <div className="flex-align gap-22">
                                    <div className="avatar-upload flex-shrink-0">
                                        <input type="file" id="imageUpload" accept=".png, .jpg, .jpeg" onChange={handleImageChange} />
                                        <div className="avatar-preview">
                                            <div
                                                id="profileImagePreview"
                                                style={{ backgroundImage: `url(${imagePreview})` }}
                                            ></div>
                                        </div>
                                    </div>
                                    <div className="avatar-upload-box text-center position-relative flex-grow-1 py-24 px-4 rounded-16 border border-main-300 border-dashed bg-main-50 hover-bg-main-100 hover-border-main-400 transition-2 cursor-pointer">
                                        <label htmlFor="imageUpload" className="position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 rounded-16 cursor-pointer z-1" />
                                        <span className="text-32 icon text-main-600 d-inline-flex"><i className="ph ph-upload" /></span>
                                        <span className="text-13 d-block text-gray-400 text my-8">Click to upload</span>
                                        <span className="text-13 d-block text-main-600">SVG, PNG, JPEG OR GIF (max 1080px1200px)</span>
                                    </div>
                                </div>
                            </div>
                           
                            <div className="col-12">
                                <div className="flex-align justify-content-end gap-8">
                                    <button
                                        type="submit"
                                        className="btn btn-main rounded-pill py-9"
                                        disabled={!isFormValid}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            {/* Modal Popup */}
            {isModalOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                    }}
                    onClick={closeModal}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            padding: "20px",
                            borderRadius: "8px",
                            textAlign: "center",
                            maxWidth: "400px",
                            width: "100%",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2>Success!</h2>
                        <p>Your details have been saved successfully.</p>
                    </div>
                </div>
            )}
        </div>
    );
}

export default StudentmyDetails;
